import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { MatProgressBar } from '@angular/material/progress-bar';
import { LoadingService } from '@shared/services/loading.service';
import { NavbarComponent } from './navbar.component';
import { KeepAliveService } from '@shared/services/keep-alive.service';
import { ParametersService } from '../parameters/parameters.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FullscreenService } from './fullscreen.service';

@Component({
    selector: 'app-home-page',
    standalone: true,
    imports: [MatTabsModule, MatButtonModule, MatIconModule, RouterOutlet, MatProgressBar, NavbarComponent],
    template: `
        <div class="absolute top-0 left-0 w-full z-50">
            @if (loadingService.loading()) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
        </div>
        <div class="flex flex-col h-full">
            <app-navbar />
            <mat-tab-nav-panel #tabPanel class="overflow-hidden flex-1 relative">
                <div
                    class="mx-auto h-full py-8"
                    [class.container]="!fullscreenService.isFullscreen()"
                    [class.p-8]="fullscreenService.isFullscreen()"
                >
                    <div class="absolute top-8 right-8 z-10 flex gap-2">
                        <button mat-icon-button color="primary" class="!flex !items-center" (click)="fullscreenService.toggleFullscreen()">
                            <mat-icon fontSet="material-icons-outlined">
                                {{ fullscreenService.isFullscreen() ? 'close_fullscreen' : 'open_in_full' }}
                            </mat-icon>
                        </button>
                    </div>
                    <router-outlet></router-outlet>
                </div>
            </mat-tab-nav-panel>
        </div>
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class HomePageComponent {
    #keepAliveService = inject(KeepAliveService);
    #parametersService = inject(ParametersService);
    #snackBar = inject(MatSnackBar);
    fullscreenService = inject(FullscreenService);
    loadingService = inject(LoadingService);

    constructor() {
        this.#keepAliveService.startPolling();
        try {
            void this.#parametersService.updateParametersFromApi();
        } catch {
            this.#snackBar.open(`Erreur lors du chargement des paramètres d'actions de régulation.`, 'Fermer', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
            });
        }
    }
}
